import React from 'react';
import { Card, Descriptions, Typography, Button, Space, Spin, Avatar, Tag, Divider } from 'antd';
import { LogoutOutlined, UserOutlined, IdcardOutlined, CalendarOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { useAppDispatch, useAppSelector } from '../../Modules/Presentation/hooks';
import { selectUser } from '../../Modules/User/Presentation/selectors';
import { logout } from '../../Modules/User/Presentation/reducers';
import dayjs from 'dayjs';
import { levelKor } from '../../Utils/permission';
import { isLimitedPartnerAdmin } from '../../Utils/limitedPartnerAdmin';

const { Title, Text } = Typography;

 

const Wrapper = styled.div`
    max-width: 860px;
    margin: 32px auto;
    padding: 8px 16px;
`;

const ProfileCard = styled(Card)`
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.06);
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 8px 4px 0 4px;
`;

const GradePill = styled(Tag)`
    && {
        background: rgba(176, 48, 82, 0.08);
        border-color: rgba(176, 48, 82, 0.2);
        color: #B03052;
        margin-left: 8px;
    }
`;

const LimitedAdminBadge = styled(Tag)`
    && {
        background: #fa8c16;
        border-color: #fa8c16;
        color: #fff;
        margin-left: 8px;
    }
`;

const MyPage: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const user = useAppSelector(selectUser);

    /* 로딩 대비 */
    if (!user) {
        return <Spin style={{ display: 'block', margin: '160px auto' }} />;
    }

    

    /* 로그아웃 → /login */
    const handleLogout = () => {
        dispatch(logout());
    navigate('/login', { replace: true });
    // 이동 직후 새로고침으로 잔여 상태를 한 번 더 정리
    setTimeout(() => window.location.reload(), 0);
    };

    return (
        <Wrapper>
            <ProfileCard>
                <Header>
                    <Avatar size={72} style={{ backgroundColor: '#B03052' }} icon={<UserOutlined />}>
                        {/* Fallback icon is shown; text avatar not used to keep consistency */}
                    </Avatar>
                    <div>
                        <Title level={3} style={{ margin: 0 }}>{user.name || user.username}</Title>
                        <div style={{ marginTop: 4 }}>
                            <Text type="secondary"><IdcardOutlined /> {user.username}</Text>
                            <GradePill>{levelKor[user.grade] ?? user.grade}</GradePill>
                            {isLimitedPartnerAdmin(user) && (
                              <LimitedAdminBadge>제한형 관리자</LimitedAdminBadge>
                            )}
                        </div>
                    </div>
                </Header>

                <Divider style={{ margin: '16px 0' }} />

                <Descriptions column={2} bordered size="small">
                    <Descriptions.Item label="이름">{user.name || '-'}</Descriptions.Item>
                    <Descriptions.Item label="아이디">{user.username}</Descriptions.Item>
                    <Descriptions.Item label="등급">{levelKor[user.grade] ?? user.grade}</Descriptions.Item>
                    <Descriptions.Item label="가입일">
                        {user.createdAt && dayjs(user.createdAt).isValid()
                            ? (<span><CalendarOutlined /> {dayjs(user.createdAt).format('YYYY-MM-DD')}</span>)
                            : '-'}
                    </Descriptions.Item>
                    {user.memo && (
                        <Descriptions.Item label="메모" span={2}>{user.memo}</Descriptions.Item>
                    )}
                </Descriptions>

                <Space style={{ marginTop: 20, width: '100%', justifyContent: 'center' }} wrap>
                    <Button danger icon={<LogoutOutlined />} onClick={handleLogout}>로그아웃</Button>
                </Space>
            </ProfileCard>
        </Wrapper>
    );
};

export default MyPage;
